/**
 * מחיר תצוגה ללקוח בחבילות נופש — מיושר עם כרטיסי תוצאות (VacationPackagesResults):
 * עדיפות ל-priceWithCommissionAndCreditCardFee כשקיים, אחרת בסיס עמלה בלבד.
 */

export function ldsOurTotalFareDisplayNis(ourTotalFare) {
  if (!ourTotalFare || typeof ourTotalFare !== "object") return 0;
  const withCc = Number(ourTotalFare.priceWithCommissionAndCreditCardFee);
  if (Number.isFinite(withCc) && withCc > 0) return withCc;
  const base = Number(ourTotalFare.priceWithCommission);
  if (Number.isFinite(base) && base > 0) return base;
  const withCard = Number(ourTotalFare.priceWithCreditCardFee);
  if (Number.isFinite(withCard) && withCard > 0) return withCard;
  const initial = Number(ourTotalFare.initialPrice);
  if (Number.isFinite(initial) && initial > 0) return initial;
  return 0;
}

export function ldsOurPriceContextDisplayNis(ourPrice) {
  if (!ourPrice || typeof ourPrice !== "object") return 0;
  const withCc = Number(ourPrice.priceWithCommissionAndCreditCardFee);
  if (Number.isFinite(withCc) && withCc > 0) return withCc;
  const base = Number(ourPrice.priceWithCommission);
  if (Number.isFinite(base) && base > 0) return base;
  return 0;
}

export function sumRoomsLdsDisplayNis(roomsAndPaxInfo) {
  const rooms = roomsAndPaxInfo || [];
  return rooms.reduce(
    (sum, r) => sum + ldsOurTotalFareDisplayNis(r?.room?.ourFareDetails?.ourTotalFare),
    0
  );
}
